@if (label) {
    @if (href$ | async; as href) {
        <a [routerLink]="href.path"
           [queryParams]="href.queryParams"
           class="label-span">{{ label!.name }}</a>
    }
}
